import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmpresaAPIService {

  private baseUrl = `${environment.APIEndpoint}empresas`;

  constructor(private http: HttpClient) { }

  getAll(pageNumber: number = 1, pageSize: number = 100, filtros: string = "") {
    let url = `${this.baseUrl}?pageNumber=${pageNumber}&pageSize=${pageSize}`;

    if (filtros) {
      url += `&${filtros}`;
    }

    return this.http.get(url);
  }

  getById(id: number) {
    return this.http.get(`${this.baseUrl}/${id}`);
  }

  create(data: any) {
    return this.http.post(this.baseUrl, data);
  }

  update(id: number, data: any) {
    return this.http.put(`${this.baseUrl}/${id}`, data);
  }

  delete(id: number) {
    return this.http.delete(`${this.baseUrl}/${id}`);
  }

}